export const consultation = {
  path: "/konsultasi",
  name: "consultasi",
  hidden: false,
  component: () => import("@/components/consultasion/index"),
  meta: {
    title: "Jadwal Konsultasi",
    icon: "fa-comment-medical",
    roles: ["pasien", "dokter"]
  },
  children: [
    {
      path: "data_konsultasi",
      name: "DataKonsultasi",
      hidden: true,
      meta: {
        title: "Data konsultasi",
        icon: "fa-area-chart",
        roles: ["pasien", "dokter"]
      },
      component: () => import("@/components/consultasion/components/masterData")
    },
    {
      path: "form_konsultasi",
      name: "formKonsultasi",
      hidden: true,
      meta: {
        title: "Form konsultasi",
        icon: "fa-area-chart",
        roles: ["pasien"]
      },
      component: () => import("@/components/consultasion/components/form")
    }
  ]
};
export default consultation;



// WEBPACK FOOTER //
// ./src/router/modules/consultation.js